<template>
  <nav v-if="total" aria-label="Pagination">
    <div class="hidden sm:block">
      <p class="text-sm text-gray-700">
        Zeige
        {{ ' ' }}
        <span class="font-medium">
          {{ from }}
        </span>
        {{ ' ' }}
        bis
        {{ ' ' }}
        <span class="font-medium">
          {{ to }}
        </span>
        {{ ' ' }}
        von
        {{ ' ' }}
        <span class="font-medium">
          {{ total }}
        </span>
        {{ ' ' }}
        Ergebnissen
      </p>
    </div>
    <div class="flex-1 flex justify-between sm:justify-end">
      <button @click="$emit('previous')" :disabled="current <= 1">
        Zurück
      </button>
      <button @click="$emit('next')" class="ml-3" :disabled="current >= last">
        Vorwärts
      </button>
    </div>
  </nav>
  <nav v-else="total">
    <div class="hidden sm:block">
      <p class="text-sm text-gray-700">
        Keine Ergebnisse
      </p>
    </div>
  </nav>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent
({
  emits: ['previous', 'next'],
  props: ['from', 'to', 'total', 'current', 'last'],
});
</script>

<style scoped>
nav
{
  @apply flex items-center justify-between;
  @apply px-4 py-3 sm:px-6;
  @apply bg-white border-t border-gray-200;
}

button
{
  @apply relative inline-flex items-center;
  @apply px-4 py-2;
  @apply border border-gray-300;
  @apply text-sm font-medium text-gray-700;
  @apply rounded-md bg-white hover:bg-gray-50;
  @apply cursor-pointer;
}
</style>
